import { useEffect, useRef, useState } from "react";
import { DatePresets } from "./datePresets";
import { Input } from "../ui/input";

export default function DateChips({ value, onChange, prefix, inputTestid, presets = ["0", "1", "3", "weekend", "monday", "7", "14"], none }) {
  const opts = DatePresets(presets);
  const match = opts.find((o) => o.date === value)?.key;
  const [custom, setCustom] = useState(!!value && !match);
  const ref = useRef(null);
  useEffect(() => { if (value && !opts.some((o) => o.date === value)) setCustom(true); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const chip = (on) => `h-9 coarse:h-10 px-3.5 rounded-full text-[13px] font-medium inline-flex items-center gap-1.5 transition-[background-color,color,transform] duration-150 active:scale-[0.97] ${on ? "bg-foreground text-background shadow-[0_4px_12px_-6px_rgba(0,0,0,0.4)]" : "bg-muted/70 text-foreground/75 hover:bg-muted hover:text-foreground"}`;
  return (
    <div>
      <div className="flex flex-wrap gap-2" data-testid={`${prefix}-group`}>
        {none && <button type="button" className={chip(!value && !custom)} onClick={() => { setCustom(false); onChange(""); }} data-testid={`${prefix}-none`}>{none}</button>}
        {opts.map((o) => (
          <button key={o.key} type="button" title={o.full} className={chip(!custom && match === o.key)} onClick={() => { setCustom(false); onChange(match === o.key && none ? "" : o.date); }} data-testid={`${prefix}-${o.key}`}>
            {o.label}{o.sub && <span className="opacity-55 font-normal">{o.sub}</span>}
          </button>
        ))}
        <button type="button" className={chip(custom)} onClick={() => { setCustom(true); setTimeout(() => ref.current?.showPicker?.(), 50); }} data-testid={`${prefix}-custom`}>Pick a date</button>
      </div>
      {custom && <Input ref={ref} data-testid={inputTestid} type="date" value={value || ""} onChange={(e) => onChange(e.target.value)} className="mt-3 rounded-xl h-11 w-auto bg-muted/40 border-0" />}
    </div>
  );
}
